<template>
  <div class="theme-switch" :title="'切换主题（当前：' + currentLabel + '）'">
    <button
      v-for="t in themes"
      :key="t.key"
      class="theme-dot"
      :class="{ active: current === t.key }"
      :style="{ background: t.preview }"
      :title="t.label"
      type="button"
      @click="set(t.key)"
    />
  </div>
</template>

<script>
// 主题切换：dark（暗紫）/ med（医学青绿）/ light（亮色），localStorage 持久化
const THEMES = [
  { key: 'dark', label: '暗夜紫', preview: 'linear-gradient(135deg,#090a10 50%,#8069ff 50%)' },
  { key: 'med', label: '医学青', preview: 'linear-gradient(135deg,#071512 50%,#2ec494 50%)' },
  { key: 'light', label: '明亮白', preview: 'linear-gradient(135deg,#f4f5fa 50%,#7a6cf5 50%)' },
];

export default {
  name: 'ThemeSwitch',
  data: () => ({
    themes: THEMES,
    current: localStorage.getItem('theme') || 'dark',
  }),
  computed: {
    currentLabel() {
      const t = this.themes.find((x) => x.key === this.current);
      return t ? t.label : '暗夜紫';
    },
  },
  created() { this.apply(this.current); },
  methods: {
    set(key) { this.current = key; localStorage.setItem('theme', key); this.apply(key); },
    apply(key) { document.documentElement.dataset.theme = key; },
  },
};
</script>

<style scoped>
.theme-switch { display: flex; gap: 7px; align-items: center; background: var(--bg-2); border: 1px solid var(--border-1); border-radius: 999px; padding: 5px 9px; }
.theme-dot { width: 18px; height: 18px; border-radius: 50%; border: 2px solid transparent; cursor: pointer; padding: 0; transition: transform 0.15s, border-color 0.2s; }
.theme-dot:hover { transform: scale(1.2); }
.theme-dot.active { border-color: var(--accent); transform: scale(1.15); }
</style>
